<template>
  <modal @before-open="beforeOpen" @opened="opened" name="schedule" :clickToClose="true" :draggable="'.header'"
         :reset="true"
         :classes="['schedule','generalbox']"
         :adaptive="true"
         :height="'80%'" :width="'80%'" :max-width="1540" :max-height="885" :min-width="1092"
         :min-height="614" :click-to-close="false">

    <div class="header">
      <h2>日程</h2>
      <div @click="close" class="close">
        <i class="iconfont icon-cha"></i>
      </div>
    </div>
    <div class="content">
      <div class="handle">
        <ul class="btnlist">
          <li @click="openDetail(0)" class="add">增加</li>
          <li :class="{'invalid':isEditInvalid}" @click="openEdit" class="edit">编辑</li>
          <li :class="{'invalid':isDelInvalid}" @click="delSchedule" class="del">删除</li>
        </ul>

        <h3 style="display: none">{{getShowDate}}</h3>
        <div title="回到今天" class="search totoday" @click="resetCondition">
          <i class="iconfont icon-shuaxin1"></i>
        </div>

        <div v-if="false" class="search">
          <button @click="resetCondition">
            回今天
          </button>
        </div>
        <div v-if="false" class="search">
          <button @click="queryKeyword">
            <i class="iconfont icon-ai219"></i>
          </button>

        </div>

        <div v-if="false" class="search">
          <input v-model="keyword" placeholder="请输入关键词" type="text"/>
        </div>
        <div class="search">
          <flat-pickr placeholder="请选择日期" v-model="filterStartTime" :config="flatPickerConfig"></flat-pickr>
        </div>
        <div class="importanceSelect">
          <multiselect v-model="currentImportantGrade"
                       :options="getImportantSelectOptions"
                       placeholder="请选择重要程度"
                       :multiple="false"
                       label="title"
                       :show-labels="false"
                       :clear-on-select="false"
                       :close-on-select="true"
                       :allow-empty="false"
                       :taggable="true"
                       @select="importanceSelect"
          ></multiselect>
        </div>
      </div>

      <div v-if="filterStartTime" class="dayDataList datalist">
        <v-table
            :row-click-color="'rgba(239,239,239,0.5)'"
            :row-click="selectRowToday"
            style="width:100%"
            :is-horizontal-resize="true"
            :columns="dayColumns"
            :table-data="dayTableData"
            :show-vertical-border="false"
            :column-cell-class-name="columnCellClass"
            :select-all="selectChange"
            :select-change="selectChange"
            :select-group-change="selectChange"
        ></v-table>
      </div>

      <div v-if="!filterStartTime" class="datalist">
        <v-table
            :row-click-color="'rgba(239,239,239,0.5)'"
            :row-click="selectRow"
            style="width:100%"
            :is-horizontal-resize="true"
            :columns="columns"
            :table-data="tableData"
            :show-vertical-border="false"
            :column-cell-class-name="columnCellClass"
            :select-all="selectChange"
            :select-change="selectChange"
            :select-group-change="selectChange"
        ></v-table>
        <div class="pagination">
          <v-pagination
              @page-change="pageChange"
              @page-size-change="pageSizeChange"
              :total="totalCount"
              :pageIndex="pageNumber"
              :page-size="pageSize"
          ></v-pagination>
        </div>
      </div>
    </div>

  </modal>
</template>

<script>
  //axios
  import axios from 'axios'
  import apiConfig from 'common/js/api_config'
  import Bus from 'common/js/bus.js';
  //日期选择器
  import flatPickr from 'vue-flatpickr-component';
  import {Mandarin} from 'flatpickr/dist/l10n/zh.js';
  import multiselect from 'vue-multiselect';
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex';
  //今天
  import {getTodayCustomDateStr} from 'common/js/getToday'

  export default {
    name: "schedule",
    data() {
      return {
        /**
         * 是否展示某一天的详情
         */
        isShowDayDetail: false,
        currentImportantGrade: {title: '全部', value: -1},
        tableData: [],
        columns: [
          {
            field: 'select',
            title: '复选',
            width: 50,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: false,
            type: 'selection'
          },
          {field: 'id', title: '序号', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: false},
          {field: 'title', title: '日程名称', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true},
          {field: 'content', title: '日程内容', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true},
          {field: 'location', title: '日程地点', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true},

          {field: 'time', title: '开始时间', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true},
          {
            field: 'endtime', title: '结束时间', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true,
            formatter: this.formatEndtime
          },
          {field: 'from', title: '日程来源', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true},
          {
            field: 'sort', title: '类型', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true,
            formatter: this.formatSort
          },
          {field: 'notice', title: '是否提醒', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true},
        ],

        //*******分页相关***********
        pageSize: 10,
        pageNumber: 1,
        pageCount: null,
        totalCount: 0,

        //搜索的关键词
        keyword: "",


        //选择结果集
        selectItems: [],
        //选择器配置
        flatPickerConfig: {
          enableTime: false,
          dateFormat: "Y-m-d",
          locale: Mandarin,
        },
        filterStartTime: null,

        //详情表格字段
        dayColumns: [
          {
            field: 'select',
            title: '复选',
            width: 50,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: false,
            type: 'selection'
          },
          {
            field: 'id',
            title: '序号',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: false,
            formatter(rowData, rowIndex, pagingIndex, field) {
              return rowIndex + 1
            }
          },
          {
            field: 'type',
            title: '日程类型',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
            formatter: this.formatSort
          },
          {field: 'starttime', title: '开始时间', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true},
          {field: 'endtime', title: '结束时间', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true},
          {field: 'location', title: '地点', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true},
          {field: 'detail', title: '详情', width: 100, titleAlign: 'center', columnAlign: 'center', isResize: true},
          {
            field: 'importance',
            title: '重要程度',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
            formatter: this.getImportantDescById
          },

        ],
        //详情表格数据
        dayTableData: [],
        //星期字典
        week_arr: ["日", "一", "二", "三", "四", "五", "六"],
      }
    },
    computed: {
      ...mapState(['importanceData']),
      ...mapGetters(['getImportanceGradeData']),
      getImportantSelectOptions() {
        let arr = [
          {
            title: '全部',
            value: -1
          }
        ]
        let ret = arr.concat(this.getImportanceGradeData)
        return ret
      },
      isEditInvalid() {
        if (this.selectItems.length === 1) {
          return false;
        }
        return true;

      },
      isDelInvalid() {
        if (this.selectItems.length) {
          return false;
        }
        return true;
      },
      getShowDate() {
        if (!this.filterStartTime) {
          return
        }
        let date = this.filterStartTime.replace(/-/g, '/')
        let week = new Date(date).getDay()
        let weekCn = '周' + this.week_arr[week]
        this.getOneDaySchedule()
        return this.filterStartTime + ' ' + weekCn
      },

    },

    methods: {
      ...mapMutations(['updateModalZIndex']),
      close() {
        this.$modal.hide("schedule");
      },
      //打开详情
      openDetail(id) {
        this.$modal.show("scheduleDetail", {id, currSelectDate: this.convertDateToLong(this.filterStartTime)})
      },
      openEdit() {
        if (this.isEditInvalid) {
          return false;
        }
        console.log("选择的结果集：", this.selectItems);
        this.$modal.show("scheduleDetail", this.selectItems);
        this.selectItems = [];
      },
      selectRow(rowIndex, rowData, column) {
        if (column.field === "select") {
          return
        }
        Bus.$emit('toSchDetailFlow', {schData: rowData})
        return
        this.$modal.show("scheduleDetail", [rowData]);
      },
      selectRowToday(rowIndex, rowData, column) {
        if (column.field === "select") {
          return
        }
        rowData.time = this.convertDateToLong(this.filterStartTime)
        rowData.sort = rowData.type
        rowData.sort = rowData.type
        rowData.stackLayout = 1
        Bus.$emit('toSchDetailFlow', {schData: rowData})
      },
      columnCellClass(rowIndex, columnName, rowData) {
        if (rowData.history === 1) {
          return 'history';
        }
        let className = ''

        if (rowData.importance === 1 || rowData.importance === 2) {
          className += ' necessary'
        }
        if (rowData.importance === 1 || rowData.importance === 3) {
          className += ' urgent'
        }
        return className

      },
      //*****分页回调******
      pageChange(pageIndex) {
        this.pageNumber = pageIndex;
        this.querySchList()
      },
      pageSizeChange(newPageSize) {
        this.pageSize = newPageSize;
        this.querySchList()
      },
      selectChange(selection) {
        this.selectItems = selection;
      },
      queryKeyword() {
        this.getOneDaySchedule()
      },
      //TODO:
      async querySchList() {

        let schData = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getScheduleList?" + this.$qs.stringify({
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
          property: 'title',
          keyword: this.keyword ? encodeURIComponent(this.keyword) : null,
          starttime: this.convertDateToLong(this.filterStartTime),
          endtime: this.convertDateToLong(this.filterStartTime)
        }));
        schData = schData.data.data[0];
        schData.list.forEach((item, index) => {
          item["notice"] = parseInt(item["warn"]) ? "是" : "否";
          item["warn"] = parseInt(item["warn"]) ? 1 : 0;
        });
        console.log("日程数据：", schData);
        this.tableData = schData.list;
        this.pageNumber = schData.pageNumber;
        this.pageCount = schData.pageCount;
        this.totalCount = schData.totalCount;
      },
      //删除
      async delSchedule() {
        let selectItems = this.selectItems;
        if (!selectItems.length) {
          return;
        }
        let selectsArr = [];
        let selectStr = "";
        selectItems.forEach((item, index) => {
          selectsArr.push(item.id);
        });

        selectStr = selectsArr.join(",");
        let res = await axios.post(apiConfig.REQUEST_URL + "/shall/front_delSchedule?ids=" + selectStr);
        this.getOneDaySchedule();
        if (res.data.status) {
          this.selectItems = [];
        }

        this.$notify({
          group: 'global',
          title: res.data.msg,
        });

      },
      //获取某一天的日程
      async getOneDaySchedule() {
        let scheduleData = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getScheduleDetail?' + this.$qs.stringify({
          day: this.convertDateToLong(this.filterStartTime),
          importance: this.currentImportantGrade ? this.currentImportantGrade.value : null
        }))
        if (!scheduleData.data.status) {
          return
        }
        scheduleData = scheduleData.data.data
        scheduleData.forEach((item) => {
          item._disabled = (item.type !== 0)
        })
        this.dayTableData = scheduleData
      },

      //日程列表
      formatSort(rowData, rowIndex, pagingIndex, field) {
        let typeName = rowData.sort || rowData.type
        switch (typeName) {
          case 0:
            return '其他'
          case 1:
            return '课程'
          case 2:
            return '会议'
          case 3:
            return '考试'
          case 4:
            return '预约（管理员）'
          case 5:
            return '预约（用户）'
          case 6:
            return '校历'
          default:
            console.log('rowData.sort异常')
            return rowData.sort
        }
      },
      //日程列表
      formatEndtime(rowData, rowIndex, pagingIndex, field) {
        if (!rowData.endtime) {
          return ''
        }
      },
      beforeOpen(data) {
        let hasStartTime
        if (!data.params) {
          data.params = {}
        }

        if (data.params.currentSelectDateStr) {
          hasStartTime = true
          this.filterStartTime = data.params.currentSelectDateStr
        } else {
          this.filterStartTime = getTodayCustomDateStr()
        }

        this.getOneDaySchedule()
        return

        if (!hasStartTime) {
          this.filterStartTime = null
        }

        this.querySchList();


      },
      opened(data) {
        this.updateModalZIndex(this.$el)
        Bus.$on('setScheduleZIndexTop', (ev) => {
          this.updateModalZIndex(this.$el)
        })
      },
      //设置模态框层级
      setModalZIndex() {
        this.$nextTick(() => {
          this.$el.style.zIndex = 9999
        })

      },
      showNotice() {
        this.$modal.show('notice')
      },
      //重置条件
      resetCondition() {
        this.filterStartTime = getTodayCustomDateStr()
        this.keyword = null
        this.currentImportantGrade = {title: '全部', value: -1}
        this.getOneDaySchedule()
        // this.querySchList()
      },
      padLeftZero: (str) => {
        str = str.toString();
        return ('00' + str).substr(str.length);
      },
      //转为长日期
      convertDateToLong(dateStr) {
        //eg:convert 2019-01-03 to 2019-1-3
        let dateArr = dateStr.split("-");
        dateArr.forEach((item, index) => {
          if (index === 0) {
            return;
          }
          dateArr[index] = this.padLeftZero(item);
        });
        dateStr = dateArr.join("-");
        return dateStr;
      },
      getImportantDescById(rowData, rowIndex, pagingIndex, field) {
        let importantValue = parseInt(rowData.importance)
        for (let i = 0; i < this.importanceData.length; i++) {
          if (parseInt(this.importanceData[i].dictId) === importantValue) {
            return `<span class="importance">${this.importanceData[i].dictName}</span>`
          }
        }
        return '/'
      },
      importanceSelect() {
        this.$nextTick(() => {
          this.getOneDaySchedule()
        })
      }
    },
    components: {flatPickr, multiselect},
    mounted() {
      Bus.$on('refreshScheduleList', (ev) => {
        if(ev.time.indexOf(':')>-1){
          ev.time=ev.time.split(' ')[0]
        }
        this.filterStartTime = ev.time
        this.getOneDaySchedule()
      })
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .content
    .datalist
      & >>> .history
        .v-table-body-cell
          span
            color #cccccc !important

      & >>> .urgent
        .v-table-body-cell
          span
            font-weight bold

      & >>> .necessary
        .importance
          color #990000

    .handle
      margin 10px
      box-shadow 2px 2px 3px #cccccc
      position relative

      &::after
        content ""
        display block
        width 100%
        clear both

      h3
        font-size 14px
        position absolute
        height 1em
        line-height 1
        text-align center
        width 200px
        top 0
        bottom 0
        left 0
        right 0
        margin auto
        color themeColor
        font-weight bold

      .btnlist
        font-size 0
        padding 10px
        height 100%
        float left

        li
          height 30px
          width 100px
          text-align center
          line-height 30px
          font-size 14px
          vertical-align middle
          display inline-block
          border-radius 15px
          color #ffffff
          background-color #ffffff
          margin-right 10px
          transition 300ms
          user-select none
          cursor pointer

          &.invalid
            background-color #cccccc !important

            &:hover
              background-color #cccccc !important

          &.add
            background-color themeColor

            &:hover
              background-color themeColor

          &.edit
            background-color rgb(25, 190, 107)

            &:hover
              background-color hsl(140, 50%, 56%)

          &.del
            background-color rgb(255, 132, 132)

            &:hover
              background-color #e45a5b

      .importanceSelect
        display inline-block
        vertical-align middle
        margin 10px
        float right

        & >>> .multiselect
          width 200px
          height 28px

      .search
        border 1px solid #ccc
        height 30px
        border-radius 15px
        overflow hidden
        margin 10px
        float right
        font-size 0

        & > *
          font-size 14px

        &.totoday
          border none
          width 50px
          text-align center
          line-height 1.4
          transition 300ms
          margin-left 0

          i
            color #004a94
            font-size 24px
            transform-origin center center
            transition 300ms
            cursor pointer
            display inline-block

          &:hover
            transform rotateZ(180deg)

        input
          padding-left 1em
          color #666666
          font-size 12px
          width 200px
          height 100%
          vertical-align top

        .flatpickr-input
          text-align center

        button

          font-size 14px
          color #666666
          outline none
          height 100%
          width 60px
          background-color #eeeeee
          border none
          transition 300ms

          &:hover
            background-color #cccccc

          i
            font-size 24px
            color #666666
</style>



// WEBPACK FOOTER //
// src/components/schedule/scheduleModal.vue